import React, { useState } from 'react';
import {
    Box,
    Tabs,
    Tab,
    Container,
    Paper
} from '@mui/material';
import MachineIntake from './MachineIntake';
import WorkInProgress from './WorkInProgress';
import ReadyForDeployment from './ReadyForDeployment';
import { useDataContext } from '../DataContext';

// Helper component for Tab Panels (from MUI docs)
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`warehouse-tabpanel-${index}`}
      aria-labelledby={`warehouse-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}> {/* Add padding top to content */}
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `warehouse-tab-${index}`,
    'aria-controls': `warehouse-tabpanel-${index}`,
  };
}

export default function WarehouseView() {
    const [currentTab, setCurrentTab] = useState(0); // 0: Intake, 1: Repairs, 2: Ready
    const { machines, isLoadingMachines } = useDataContext(); // Get machines and loading state

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    // Calculate counts
    const wipCount = isLoadingMachines 
        ? 0 
        : machines.filter(m => m.machine_status === 'servicing').length;
    const readyCount = isLoadingMachines 
        ? 0 
        : machines.filter(m => m.machine_status === 'ready_to_deploy').length;

    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 4, pt: 8, minHeight: 'calc(100vh - 80px)' }}> {/* Use xl for wider view */} 
            <Paper sx={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}> {/* Ensure Paper fills container */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs 
                        value={currentTab} 
                        onChange={handleChange} 
                        aria-label="Warehouse process tabs"
                        variant="fullWidth"
                        sx={{
                            "& .MuiTabs-indicator": {
                                backgroundColor: (theme) => theme.palette.persiangreen?.main || 'primary.main',
                            },
                            "& .MuiTab-root": {
                                color: (theme) => theme.palette.text.secondary,
                            },
                            "& .Mui-selected": {
                                color: (theme) => theme.palette.persiangreen?.main + ' !important' || 'primary.main !important',
                            }
                        }}
                    >
                        <Tab label="Machine Intake" {...a11yProps(0)} />
                        <Tab label={`Repairs ${wipCount > 0 ? `(${wipCount})` : ''}`} {...a11yProps(1)} />
                        <Tab label={`Ready to Deploy ${readyCount > 0 ? `(${readyCount})` : ''}`} {...a11yProps(2)} />
                    </Tabs>
                </Box>
                {/* Ensure Panels can grow */}
                <Box sx={{ flexGrow: 1 }}> 
                    <CustomTabPanel value={currentTab} index={0}>
                        {/* Render MachineIntake component here */}
                        {/* Pass necessary props if needed */}
                        <MachineIntake /> 
                    </CustomTabPanel>
                    <CustomTabPanel value={currentTab} index={1}>
                        {/* Render WorkInProgress component here */}
                        <WorkInProgress />
                    </CustomTabPanel>
                    <CustomTabPanel value={currentTab} index={2}>
                        {/* Render ReadyForDeployment component here */}
                        <ReadyForDeployment />
                    </CustomTabPanel>
                </Box>
            </Paper>
        </Container>
    );
} 